import React from 'react';
var ProgressBarSkeleton = function () { return (React.createElement("div", { className: "progress" },
    React.createElement("span", { className: "skeleton-line h-100 w-100" }))); };
export default React.memo(ProgressBarSkeleton);
